import { put, takeLatest, takeEvery } from 'redux-saga/effects';
import { delay } from '@services/sagas';
import { displaySnackBar, types, hideSnackBar } from '@actions/snackbar';
import { types as introMessagesTypes } from '@actions/introMessages';
import { types as conferencesTypes } from '@actions/conferences';
import { types as conferenceTypes } from '@actions/conference';
import { types as transcriptTypes } from '@actions/transcript';
import { types as transcriptsTypes } from '@actions/transcripts';
import { types as organizationsTypes } from '@actions/organizations';
import { types as errorLoggerTypes } from '@actions/errorLogger';
import { types as attendeeTypes } from '@actions/attendees';
import { types as trscTypes } from '@actions/trscService';

export function* displaySuccessNotificationSaga(action) {
  yield put(displaySnackBar(true, action.message || 'Success'));
}

export function* displayFailureNotificationSaga(action) {
  yield put(displaySnackBar(false, action.message || 'Something went wrong'));
}

export function* displayStartedNotificationSaga(action) {
  yield put(displaySnackBar(false, action.message || 'Started'));
}

export function* waitAndHideSnackbar() {
  yield delay(4000);
  yield put(hideSnackBar());
}

export default function*() {
  yield takeEvery(types.DISPLAY, waitAndHideSnackbar);
  // Error logger actions.
  yield takeLatest(errorLoggerTypes.LOG_ERROR.SUCCESS, displaySuccessNotificationSaga);
  yield takeLatest(errorLoggerTypes.LOG_ERROR.FAILURE, displayFailureNotificationSaga);
  // Intro messages actions.
  yield takeLatest(
    introMessagesTypes.GET_INTRO_MESSAGES.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    introMessagesTypes.CREATE_INTRO_MESSAGE.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    introMessagesTypes.DISABLE_INTRO_MESSAGE.FAILURE,
    displayFailureNotificationSaga,
  );
  // Conferences actions.
  yield takeLatest(
    conferencesTypes.CALL_ATTENDEE.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.CALL_ATTENDEE.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.GET_CONFERENCES_LIST.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.REGENERATE_PIN_FROM_DASHBOARD.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.REGENERATE_PIN_FROM_DASHBOARD.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.CANCEL_CONFERENCE_CALL.STARTED,
    displayStartedNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.CANCEL_CONFERENCE_CALL.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferencesTypes.CANCEL_CONFERENCE_CALL.FAILURE,
    displayFailureNotificationSaga,
  );
  // Conference actions.
  yield takeLatest(conferenceTypes.INSERT.SUCCESS, displaySuccessNotificationSaga);
  yield takeLatest(conferenceTypes.INSERT.FAILURE, displayFailureNotificationSaga);
  yield takeLatest(conferenceTypes.GET_BY_ID.FAILURE, displayFailureNotificationSaga);
  yield takeLatest(
    conferenceTypes.GET_BY_LINKS_UUID.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.CREATE_CONFERENCE.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.CREATE_CONFERENCE.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.UPDATE_CONFERENCE.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.UPDATE_CONFERENCE.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.REGENERATE_PIN.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.REGENERATE_PIN.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.REQUEST_HUMAN_TRANSCRIPT.STARTED,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.REQUEST_HUMAN_TRANSCRIPT.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    conferenceTypes.REQUEST_HUMAN_TRANSCRIPT.FAILURE,
    displayFailureNotificationSaga,
  );
  // Transcript actions
  yield takeLatest(transcriptTypes.INSERT.SUCCESS, displaySuccessNotificationSaga);
  yield takeLatest(transcriptTypes.INSERT.FAILURE, displayFailureNotificationSaga);
  yield takeLatest(
    transcriptsTypes.RESUBMIT_TRANSCRIPT.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    transcriptsTypes.RESUBMIT_TRANSCRIPT.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    transcriptTypes.CHANGE_SPEAKER_NAMES.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    transcriptTypes.CHANGE_SPEAKER_NAMES.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    transcriptsTypes.GET.TRANSCRIPT_RECORDINGS_LINKS.FAILURE,
    displayFailureNotificationSaga,
  );
  // Error logger actions.
  yield takeLatest(errorLoggerTypes.LOG_ERROR.SUCCESS, displaySuccessNotificationSaga);
  yield takeLatest(errorLoggerTypes.LOG_ERROR.FAILURE, displayFailureNotificationSaga);
  // Organizations actions
  yield takeLatest(
    organizationsTypes.UPDATE_ORGANIZATION.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    organizationsTypes.CREATE_ORGANIZATION.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(organizationsTypes.LOAD_RULES.FAILURE, displayFailureNotificationSaga);
  yield takeLatest(
    organizationsTypes.UPDATE_ORGANIZATION.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    organizationsTypes.CREATE_ORGANIZATION.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    attendeeTypes.REQUEST_TRANSCRIPT_COMPLETION_EMAIL.SUCCESS,
    displaySuccessNotificationSaga,
  );
  yield takeLatest(
    attendeeTypes.REQUEST_TRANSCRIPT_COMPLETION_EMAIL.FAILURE,
    displayFailureNotificationSaga,
  );
  yield takeLatest(
    trscTypes.GET_AVAILABLE_LANGUAGES.FAILURE,
    displayFailureNotificationSaga,
  );
}



// WEBPACK FOOTER //
// ./redux/sagas/snackbar.js